import adviseLogo from "../assets/img/advise_consultore_logo-removebg-preview.png";
import { faFacebook, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

const options = [
    { titulo: "Inicio", ruta: "" },
    { titulo: "Quienes somos", ruta: "us" },
    { titulo: "Nuestros Servicios", ruta: "services" },
    { titulo: "Nuestros Productos", ruta: "products" },
    { titulo: "Nuestros Clientes", ruta: "clients" },
    { titulo: "Contacto", ruta: "contact-us" },
    { titulo: "Ayuda", ruta: "ayuda" }
];

const optionsService = [
    { titulo: "Inicio", ruta: "" },
    { titulo: "Características", ruta: "characteristics" },
    { titulo: "Contacto", ruta: "contact-us" },
    { titulo: "Políticas de privacidad", ruta: "/SiGGER360/privacyPolicy" }
]

const optionsPolicy = [
    { titulo: "Inicio", ruta: "privacy-policy" },
    { titulo: "Volver a SiGGER360", ruta: "/SiGGER360" },
    { titulo: "Volver a Advise", ruta: "/" },
]

export default function Footer(props) {

    const navigate = useNavigate();
    
    const optionsShow = props.isService ? optionsService : props.isPolicy ? optionsPolicy : options;

    const scrollToSection = (event, sectionId, isProduct) => {
        event.preventDefault();
        const targetElement = document.getElementById(sectionId);
    
        if(targetElement !== null && targetElement !== undefined){
            const offset = !isProduct ? 50 : 0;
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = Math.max(elementPosition + window.pageYOffset - offset, 0);
    
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        } 
        else{
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }  
    };

    const handleNavigation = (event, ruta) => {
        if (ruta.includes("/")) {
            event.preventDefault(); 
            window.scrollTo({
                top: 0,
                behavior: "instant"
            });
            navigate(ruta);

        } else {
            scrollToSection(event, ruta, props.isService);
        }
    };

    return (
        <>
            <div id="footer" className="bg-advise-color">
                <div className="container px-5 py-8 mx-auto footer-top sm:py-12">
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
                        <div>
                            <a href='/'>
                                <img src={adviseLogo} alt="logoAdvise" className="w-full mb-3 max-w-40"/>
                            </a>   
                            <p className="text-base text-white">Colaborando con soluciones tecnológicas a los negocios de nuestros clientes</p>
                        </div>

                        <div className="footer-links">
                            <h4 className="mb-5 text-base font-extrabold text-white">NAVEGACIÓN</h4>
                            <ul>
                                {optionsShow.map((option, index) => (
                                    <li key={index} onClick={(e) => handleNavigation(e, option.ruta)}>
                                        {option.titulo}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div>
                            <h4 className="mb-5 text-base font-extrabold text-white">CONTÁCTENOS</h4>
                            <p className="text-white">
                                <a href={'https://maps.app.goo.gl/TAmstWpgFp16qqZH6'} target={'_blank'} rel={'noreferrer'}><strong>Dirección:</strong> Rafael Cañas 50, Piso 2<br/>
                                    Providencia, Santiago<br/>
                                    Chile<br/>
                                </a>
                                <a href={'tel:+56982990118'}><strong>Teléfono:</strong> +569 8299 0118<br/></a>
                                <a href={'mailto:contacto@advise.cl'}><strong>Email:</strong> contacto@advise.cl<br/></a>
                            </p>
                            <div className="pt-4 google-map">
                                <iframe
                                    id={'frame1'}
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3330.478837336229!2d-70.63724868480797!3d-33.42696398078339!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9662cf64ecbac5e7%3A0x60b0dfde57d62c97!2sRafael%20Cañas%2050%2C%20Providencia%2C%20Regi%C3%B3n%20Metropolitana%2C%20Chile!5e0!3m2!1sen!2sus!4v1591985238975!5m2!1sen!2sus"
                                    width="100%"
                                    height="200"
                                    title={"Google Maps location of Rafael Cañas 50, Providencia, Chile"}
                                    frameBorder="0"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    aria-hidden="false"
                                    tabIndex="0"
                                ></iframe>
                            </div>
                        </div>

                        <div className="footer-newsletter">
                            <h4 className="mb-5 text-base font-extrabold text-white">REDES SOCIALES</h4>
                            <div className="social-links">
                                <a href="https://www.facebook.com/AdviseChile" target="_blank" className="facebook" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faFacebook} />
                                </a>
                                <a href="https://www.linkedin.com/company/advise-consultores" target="_blank" className="linkedin" rel="noopener noreferrer">
                                    <FontAwesomeIcon icon={faLinkedin} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-center py-4 align-center bg-advise-color-dark">
                <p className="text-sm text-white">© Copyright <b>Advise</b>. Todos los derechos reservados v1.2.0</p>
            </div>
        </>
    );
}
